import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  I13N_ACTION_VIEW,
  I13N_CATEGORY_UI,
  I13N_TYPE_FEATURE_COUNT,
} from 'Lib/constants/i13nSpec';
import isInStandaloneMode from 'Lib/utils/isInStandaloneMode';

import { BeforeInstallPromptEvent, setBeforeInstallPromptEvent } from 'Store/notifications/utils';
import { setUpsellShown } from 'Store/purchase/actions';

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}
const useAddToHomeHandle = ({
  executeEvent,
}: {
  executeEvent?: (b: string, a: Record<string, any>) => void;
}) => {
  const dispatch = useDispatch();
  const deferHomeScreenPrompt = useCallback((e: BeforeInstallPromptEvent) => {
    // Stash the event so it can be triggered later.
    e.preventDefault();
    setBeforeInstallPromptEvent(e);
    return false;
  }, []);

  useEffect(() => {
    const option = { once: true };
    if (isInStandaloneMode) {
      dispatch(setUpsellShown({ upsellType: 'homeScreenTooltip' }));
      executeEvent?.(I13N_TYPE_FEATURE_COUNT, {
        category: I13N_CATEGORY_UI,
        action: I13N_ACTION_VIEW,
        label: 'AppStart',
        message: 'Launch From Homescreen',
        sampleRate: 0.01,
      });
    } else {
      window.addEventListener('beforeinstallprompt', deferHomeScreenPrompt, option);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', deferHomeScreenPrompt);
    };
  }, [deferHomeScreenPrompt, dispatch, executeEvent]);
};

export default useAddToHomeHandle;
